<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/rolf-harris.jpg">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Question 3</span>
            <br>
            <span>Guilty or Innocent?</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="$store.question" :disabled="getShowAnswer">
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:false})"
              label="Guilty"
              value="Wrong: Only the court of King Caractacus can judge him."
            ></v-radio>
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:true})"
              label="Innocent"
              value="Correct: We all know it was a set up."
            ></v-radio>
          </v-radio-group>
          <span v-if="getShowAnswer" >{{ getAnswer }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="getAnswer && !getShowAnswer" @click="showAnswer()" >Get Answer</v-btn>
          <v-btn v-if="getShowAnswer" to="/question4" flat color="orange">Next Question</v-btn>
          <v-spacer></v-spacer><span class="grey--text">Current score: {{getScore}}</span>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  methods: mapMutations(['showAnswer', 'updateAnswer', 'nextQuestion']),
  computed: mapGetters(['getScore', 'getAnswer', 'getShowAnswer']),
    created() {
     this.$store.dispatch('resetQuestion');
   },
};
</script>